module.exports = "div.createUsersCard {\n  margin-top: 0em;\n  width: 55em; }\n"